import header from '../modules/header';
import swiper from '../modules/swiper';
import body from '../modules/body';
import leaders from '../modules/about-us';
import arrow from '../modules/arrow';

export default {
  init() {
    // JavaScript to be fired on all pages

    header();
    body();
    leaders();
    arrow();
    // $(window).on('load', function() {
      setTimeout(() => {
        swiper();
      }, 200);
    // })
},
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js